module.exports = __webpack_public_path__ + "images/stickers/taco-pixel@2x.3751a48869a42911093b.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/taco-pixel@2x.png
// module id = Pjce
// module chunks = 13